import { account, AccountResolved } from '@/db/schema/account'
import { expense, expenseType } from '@/db/schema/expense'
import { income, incomeType } from '@/db/schema/income'
import { salary, salaryType } from '@/db/schema/salary'
import { transfer, transferType } from '@/db/schema/transfer'
import { decimal, index, integer, PgColumn, pgEnum, pgTable, serial, text, timestamp } from 'drizzle-orm/pg-core'

export const bookingType = pgEnum('booking_type', [
  ...transferType.enumValues,
  ...salaryType.enumValues,
  ...expenseType.enumValues,
  ...incomeType.enumValues,
])

export const booking = pgTable(
  'booking',
  {
    id: serial('id').primaryKey(),
    migrationId: text('migration_id'),
    created: timestamp().defaultNow().notNull(),
    updated: timestamp().defaultNow().notNull(),
    issued: timestamp().defaultNow().notNull(),
    accountId: integer('account_id')
      .references((): PgColumn => account.id)
      .notNull(),
    oppositeAccountId: integer('opposite_account_id')
      .references((): PgColumn => account.id)
      .notNull(),
    name: text().notNull(),
    amount: decimal().notNull().default('0'),
    type: bookingType().notNull(),
  },
  (t) => ({
    typeIdx: index('booking_type_idx').on(t.type),
    oppositeAccountIdIdx: index('booking_opposite_account_id_idx').on(t.type),
  })
)

export type Booking = typeof booking.$inferSelect & {
  account?: AccountResolved
  oppositeAccount?: AccountResolved
  origin: { incomeId?: number; transferId?: number; salaryId?: number; expenseId?: number }
}
export type InsertBooking = typeof booking.$inferInsert
export type UpdateBooking = Partial<Booking>

export const incomeBooking = pgTable('income_booking', {
  bookingId: integer('booking_id')
    .references(() => booking.id, { onDelete: 'cascade' })
    .unique()
    .notNull(),
  incomeId: integer('income_id')
    .references(() => income.id, { onDelete: 'cascade' })
    .notNull(),
})

export const expenseBooking = pgTable('expense_booking', {
  bookingId: integer('booking_id')
    .references(() => booking.id, { onDelete: 'cascade' })
    .unique()
    .notNull(),
  expenseId: integer('expense_id')
    .references(() => expense.id, { onDelete: 'cascade' })
    .notNull(),
})

export const salaryBooking = pgTable('salary_booking', {
  bookingId: integer('booking_id')
    .references(() => booking.id, { onDelete: 'cascade' })
    .unique()
    .notNull(),
  salaryId: integer('salary_id')
    .references(() => salary.id, { onDelete: 'cascade' })
    .notNull(),
})

export const transferBooking = pgTable('transfer_booking', {
  bookingId: integer('booking_id')
    .references(() => booking.id, { onDelete: 'cascade' })
    .unique()
    .notNull(),
  transferId: integer('transfer_id')
    .references(() => transfer.id, { onDelete: 'cascade' })
    .notNull(),
})
